module.exports = __webpack_public_path__ + "static/media/swift.39581203.png";